module.exports = __webpack_public_path__ + "img/profile-small-mid-green.53da4361.svg";